module.exports = __webpack_public_path__ + "img/footer-blur.5b81cc26.png";